export default __webpack_public_path__ + "static/media/duck.be7aa8f9.png";